import { BearerType } from 'Quotes/QuoteBuilder/components/Configure/Bearer/BearerType';
import { Supplier } from '../types/supplier';
import { formatBandwidth } from 'shared/utils/connectionCapacity';

export const getSupplier = (supplier: Supplier | null, isPoA: boolean | null): Supplier => {
  // TODO: Fix type system so we actually support `null`
  if (supplier) return supplier;
  if (isPoA) return Supplier.NNAT;
  return Supplier.NONE;
};

export function presentSupplierName(supplier: Supplier | string): string {
  switch (supplier) {
    case Supplier.OPENREACH:
      return 'Openreach';
    case Supplier.VIRGIN:
      return 'Virgin';
    case Supplier.BT_WHOLESALE:
      return 'BT Wholesale';
    case Supplier.CITYFIBRE:
      return 'CityFibre';
    case Supplier.VODAFONE:
      return 'Vodafone National';
    case Supplier.NONE:
    case Supplier.ONAT:
    case Supplier.NNAT:
      return 'Neos Networks';
    case Supplier.SKY:
      return 'Sky';
    case Supplier.SKY_ITS:
      return 'Sky via ITS';
    case Supplier.TALKTALK:
      return 'PXC';
    case Supplier.ITS_FIBRELIGHT:
      return 'ITS FibreLight';
    case Supplier.ITS_FIBREBRIGHT:
      return 'ITS FibreBright';
    default:
      return supplier;
  }
}

export function isCityFibreFlex(supplier: Supplier | string, bandwidth: string | null | undefined, port?: BearerType): boolean {
  return supplier === Supplier.CITYFIBRE && port === BearerType.MEDIUM && (bandwidth === "100" || bandwidth === "200");
}

export function isMultilineSupplierText(supplier: Supplier | string, bandwidth: string | null | undefined, port?: BearerType): boolean {
  return isCityFibreFlex(supplier, bandwidth, port);
}

export function presentAccessMethodForSupplier(supplier: Supplier | string, accessMethod: string, bandwidth: string | null | undefined, port?: BearerType): string {

  let portStr = '';
  switch (port) {
    case BearerType.SMALL:
      portStr = "100 Mbps"; break;
    case BearerType.MEDIUM:
      portStr = "1 Gbps"; break;
    case BearerType.LARGE:
      portStr = "10 Gbps"; break;
  }

  if (isCityFibreFlex(supplier, bandwidth, port)) {
    return `Ethernet Flex <br> Up to ${portStr} burstable`;
  } 
  
  if (supplier === Supplier.ITS_FIBRELIGHT && bandwidth) {
    if (bandwidth === "2000") bandwidth = "2500";
    const bandwidthStr = formatBandwidth(bandwidth);
    return `Up to ${bandwidthStr} burstable`;
  }

  return accessMethod;
}

export function presentSupplierNameForPriceTile(supplier: Supplier | string | null | undefined): string {
  if (!supplier) {
    return ''; // or any default value you want to return
  }

  switch (supplier) {
    case Supplier.OPENREACH:
      return "via Openreach";
    case Supplier.SKY_ITS:
      return "via ITS";
    case Supplier.ITS_FIBRELIGHT:
      return "ITS FibreLight (EoFTTP)";
    default:
      return presentSupplierName(supplier);
  }
}

export const isNeosNetworksSupplier = (supplier: Supplier) => {
  return [Supplier.NONE, Supplier.ONAT, Supplier.NNAT].includes(supplier);
};

export const supplierListIncludesNeosNeworksSupplier = (list: Supplier[]) => {
  return list.includes(Supplier.NONE) || list.includes(Supplier.ONAT) || list.includes(Supplier.NNAT);
};
